export const TARGET_ID_PROMOTIONAL_VOUCHER_BANNER =
    '#portal-c24-promotional-voucher-banner';
export const TARGET_ID_PROMOTIONAL_VOUCHER_LAYER =
    '#portal-c24-promotional-voucher-layer';
